/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useCallback, useEffect, useImperativeHandle }  from 'react'; // we need this to make JSX
import { useForm } from 'react-hook-form';
import { Grid, Typography, Divider } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { AUTH_STRINGS } from '../../../../constants/strings';
import { Logger } from '../../../../libs/utils/logger';
import { FxTextEdit } from '../../../Input/FxText/FxTextEdit';
import { FxButton } from '../../../Action/FxButton';
import usa_state from '../../../Utils/usa_states.json';
import FxLabelView from '../../../Input/FxLabel/FxLabelView';
import FxCardHeader from '../../../Container/FxCardHeader';
import FxCard from '../../../Container/FxCard';
import FxCardBody from '../../../Container/FxCardBody';
import FxCardFooter from '../../../Container/FxCardFooter';
import { getKey, setKey } from '../../../../libs/utils/storageManager';
import { ageLimit, convertToPhoneDisplayFormat, handleAddressChange, handleKeyDownChange, handleZipChange, setItinValidationOptions, setPhoneValidationOptions, setSsnValidationOptions, setZipValidationOptions, ShowInfoToolTip, updateComponentParams , handleFieldChange, handleDateValidation, setCityValidation, fetchDataFromState, isNullOrUndefined} from '../../../Utils/CommonBaseClass';
import { ReactComponent as ContactsIcon } from '../../../../assets/svg/contacts-emty.svg';
import { ReactComponent as PhoneVerificationICon } from '../../../../assets/svg/verification.svg';
import { FxDateEdit } from '../../../Input/FxDate/FxDateEdit';
import FxPhoneEdit from '../../../Input/FxPhone/FxPhoneEdit';
import { FxTextEditSSN } from '../../../Input/FxSSN/FxTextEditSSN';
import { RegisterComponent } from '../../../../libs/saga/dataSaga';
import { useDispatch, useSelector } from 'react-redux';
import FxMaterialSelect from '../../../Input/FxSelect/FxMaterialSelect';
import { FieldErrorMessageRender } from '../Common/FieldErrorMessageRender';
import { SignUpIndividualDetailsRef } from '../Individual/SignUpIndividualDetails';
import { saveNodeData, savePerFieldData } from '../../../../libs/utils/autoSaveField';
import { getCustomerUrl } from '../../../../libs/utils/utils';
import HttpClient from '../../../../libs/utils/httpClient';
const httpClient = HttpClient.getClient();


/**
 * Component: JointTenancyIdentificationSignUp
 * Usage: Joint tenanct SignUp Individual Details Add page
 */

Logger.debug("JointTenancyIdentificationSignUp.tsx", "SignUp identification initializing")

// Phone validation constant
const setEmailValidationOptions = {
    required: true,
    maxLength: 250,
    pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i,
        message: AUTH_STRINGS.ERRORS.EMAIL_INVALID_REGEXP,
    },
};

 /**
  *  Address line 1 validation constant
  * */ 
const setAddressLine1Validation = {
    required: true,
    minLength: {
        value: 4,
        message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
    },
    maxLength: {
        value: 40,
        message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
    }
}

export const JointTenancyIdentificationSignUp = React.memo(forwardRef<SignUpIndividualDetailsRef, any>((props, ref) => {
        const { register, formState: { errors }, handleSubmit, setValue, control, clearErrors, setError, watch, getValues } = useForm({mode: 'onChange',reValidateMode:'onChange'});
        ({ props } = RegisterComponent(props));
        const isSmallScreen = useMediaQuery({ query: '(max-width: 600px)' })
        const defaultTaxIdentifier =  ((props?.data?.taxIdentifier && props?.data?.taxIdentifier === 'itin') || (!props?.data?.taxIdentifier && props?.data?.itin)) ? 'itin' : 'ssn';
        const taxIdentifier = watch('taxIdentifier') || defaultTaxIdentifier;
        const taxIdentifierData = [
            { label: "SSN", value: "ssn" },
            { label: "ITIN", value: "itin" },
        ];
        const invitationType = getKey('invitationType')
        const dispatch = useDispatch();

        /**
         * This useEffect basically checks sets the primaryAddress node as true for the onboardingForm API
         */
        useEffect(() => {
                const req = {
                    "owners[0].mailingAddress[0].isPrimary": true,
                    "owners[0].firstName": getKey('firstName'),
                    "owners[0].lastName": getKey('lastName'),
                    "owners[0].email": getKey('email'),
                    "owners[0].portalAccess.grantAccess": true,
                    
                }
                savePerFieldData(req, '/onboardingFormData');
        }, [getKey, savePerFieldData]);

        /**
         * This method fetches the previously saved data from the GET autoSaved API
         * and sets the values in the form fields
         */
       const fetchOnboardingFormData = useCallback(async () => {
            const previouslySavedData = await getPreviouslySavedDataFromOnboardingApi();

            if (
                previouslySavedData?.data?.flatFields
            ) {
                const data = previouslySavedData.data.flatFields;
                updateComponentParams(dispatch, props.id, { autoSavedData: data });
            }
        }, [dispatch, props.id]);

        /**
         * This useEffect hook is used to fetch the previously saved data from the GET autoSaved API
         */
        useEffect(() => {
            fetchOnboardingFormData();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[fetchOnboardingFormData])

        /**
         * UseEffect to set the values of the fields on the update of the autoSavedData state
         */
        useEffect(() => {
            if (props?.autoSavedData) {
                const ownerPath = 'owners[0]';
                const addressPath = `${ownerPath}.mailingAddress[0]`;
              
                const fieldsMap: Record<string, string> = {
                  firstName: `${ownerPath}.firstName`,
                  lastName: `${ownerPath}.lastName`,
                  middleName: `${ownerPath}.middleName`,
                  dob: `${ownerPath}.dob`,
                  ssn: `${ownerPath}.ssn`,
                  itin: `${ownerPath}.taxIdentification.id`,
                  addressLine1: `${addressPath}.addressLine1`,
                  addressLine2: `${addressPath}.addressLine2`,
                  city: `${addressPath}.city`,
                  state: `${addressPath}.state`,
                  zip: `${addressPath}.zip`,
                  mobilePhone: `${ownerPath}.mobilePhone`,
                };
              
                Object.entries(fieldsMap).forEach(([field, path]) => {
                    if(props.autoSavedData?.[path]){
                        setValue(field, props.autoSavedData?.[path]);
                    }
                });
              
                const ssn = props.autoSavedData?.[`${ownerPath}.ssn`];
                const itin = props.autoSavedData?.[`${ownerPath}.taxIdentification.id`];
                if(ssn || itin)
                    setValue('taxIdentifier', !ssn && itin ? 'itin' : 'ssn');
              }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[props?.autoSavedData, setValue])


        /**
         * Calling the GET autosave api to get the previously saved data
         * @returns 
         */
        const getPreviouslySavedDataFromOnboardingApi = async () => {
                    try {
                        let apiName: any = '/onboardingFormData'
                        return await httpClient.get(getCustomerUrl(apiName,false));
                    } catch (err) {
                        Logger.error("JointTenancyIdentificationSignUp.tsx", "getPreviouslySavedDataFromOnboardingApi", "error", err);
                        return err;
                    }
                }

        /**
         * Exposes the `submitForm` method to parent components via `ref`.
         * 
         * - Uses the `handleSubmit` function (likely from `react-hook-form`) to handle form submission and validation.
         * - On successful submission, sets the `result` object to `{ success: true, errors: {} }`.
         * - If form validation fails, sets the `result` object to `{ success: false, errors: <form errors> }`.
         * - Returns the `result` object to indicate the success or failure of the form submission, along with any validation errors.
         */
        useImperativeHandle(ref, () => ({
            submitForm: async (options: { isClearError?: boolean } = { isClearError: false }) => {
                
                let result:any = {};
                await handleSubmit(
                    async (data) => {
                        fetchOnboardingFormData();
                        await onSubmit(data);
                        result = { success: true, data, errors:{} };
                    },
                    (formErrors) => {
                        if(options?.isClearError){
                            clearErrors();
                        }
                        result = { success: false, errors: formErrors };
                    }
                )();
                return result;
            }
        }));


        useEffect(() => {
            const { ssn, itin } = props.data || {};

            const disableTaxIdentifierDropdown = !!(ssn || itin);

            updateComponentParams(dispatch, props.id, {
                isLoading: false,
                ssn: false,
                itin: false,
                disableTaxIdentifierDropdown,
            });
        },[
            dispatch,
            props.id
        ])

        useEffect(() => {
            // Reset the value of the selected taxIdentifier (SSN or ITIN) field when the taxIdentifier changes
            setValue(taxIdentifier, props?.data?.itin || props?.data?.ssn);
            
            // Clear any errors for the field that is not selected
            clearErrors(taxIdentifier === 'ssn' ? 'itin' : 'ssn');
        }, [taxIdentifier]);
      
        /**
         * Method to handle on submit event
         * @param data :data
         */
        async function onSubmit(data: any) {
            setKey('jtIdentificationForm','valid');
            if (props.onSubmit) {
                updateComponentParams(dispatch, props.id, { isLoading: true })
                props.onSubmit(data,()=>{
                    updateComponentParams(dispatch, props.id, { isLoading: false })
                });
            }
        }

         useEffect(() => {
              const primaryOwner = props.data;
              if(primaryOwner) {
                setValue('firstName', primaryOwner.firstName)
                setValue('middleName', primaryOwner.middleName)
                setValue('lastName', primaryOwner.lastName)
                setValue('dob', primaryOwner.dob)
                setValue('addressLine1', primaryOwner.addressLine1)
                setValue('addressLine2', primaryOwner.addressLine2)
                setValue('city', primaryOwner.city)
                setValue('state', primaryOwner.state)
                setValue('zip', primaryOwner.zip)
                setValue('mobilePhone', primaryOwner.mobilePhone)
                setValue('email', primaryOwner.email)
              } else {
                if (getKey('email') && getKey('phone') && getKey('firstName') && getKey('lastName')) {
                  setValue('email', getKey('email'))
                  setValue('mobilePhone', convertToPhoneDisplayFormat(getKey('phone')))
                  setValue('firstName', getKey('firstName'))
                  setValue('lastName', getKey('lastName'))
                }
              }
         },[props.data]);

        /**
         * Error messages for Date of Birth (DOB) validation:
         * - futureDate: Error if the DOB is a future date (not allowed)
         * - maxDate: Error if the DOB indicates the user is less than 18 years old
         * - minDate: (optional) Error if the DOB is before a very old date (not needed here)
         */ 
        const dobErrorMsg={
            futureDate:AUTH_STRINGS.ERRORS.JOINT_TENANCY_FUTURE,
            maxDate:AUTH_STRINGS.ERRORS.JOINT_TENANCY_LESS_THAN_18,
           }

        /**
         * Method fetches data from the state
         */
        const jointOwnerState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-joint-owners-data')
        );


        /**
         * Handles auto-saving of a single form field.
         *
         * This function delegates the save logic to `saveNodeData`, passing in the current field name and value,
         * along with necessary form and state management functions like `setValue`, `getValues`, `dispatch`,
         * and the `individualState`. This ensures that field changes are persisted automatically.
         *
         * @param fieldName - The name of the field being updated.
         * @param value - The new value to be saved.
        */
        const handleAutoSave = (fieldName: string, value: any) => {
            saveNodeData('jt-basic-info-page', fieldName, value, setValue, getValues, dispatch, jointOwnerState);
        }

        const handleDateOfBirthValueChange = (value:any) => {
            handleDateValidation("dob", value, setValue, setError, clearErrors, true, ageLimit(18),null,dobErrorMsg);
            isNullOrUndefined(errors?.dob) && handleAutoSave('dob', value);
        }

        /**
         * Method handles the change event for the state dropdown field
         * @param e 
         * @param fieldName 
         */
        const handleStateOnChangeEvents = (e: any, fieldName: string) => {
            handleFieldChange('state', e, setValue, clearErrors)
            handleAutoSave('state', e);
        }

        return (
            <Grid xs={12} className='signup-detail-page-bg'>
                <Grid container id="create-external-account-main-grid" xs={12}  justifyContent="center">
                    <Grid item xs={12} sm={isSmallScreen?undefined:11} md={isSmallScreen?undefined:7}>
                        <FxCard id="customer-signup-info-card" className={!isSmallScreen?"fx-theme-passport-no-before fx-no-shadow fx-signup-formkyc fx-individual-details fx-signup-formkyc-individual-margin":"fx-theme-passport-no-before fx-no-shadow fx-signup-formkyc  fx-individual-details"}>
                            <div className="fx-form-edit-profile" >
                                {<form id='signup-details-form' onSubmit={handleSubmit(onSubmit)} >
                                    <FxCardHeader id="customer-signup-form-card-header">
                                    <Grid container direction="row" xs={12}   >
                                            <Grid item xs={12} className='fx-signup-formkyc-topblock'>
                                                <Grid item xs={12} container flexWrap={'nowrap'}>
                                                    <Grid item className={"fx-signup-formkyc-topblock-icon"}>
                                                    <ContactsIcon />
                                                    </Grid>
                                                    <Grid item>
                                                    <Typography id="customer-signup-form-card-title" variant="h3" >
                                                        Tell us about yourself
                                                    </Typography>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                        <Typography id="customer-signup-form-card-title" variant="h6" className={isSmallScreen?"fx-word-wrap":''}>
                                                        To keep your account secure, we need to verify some details. This helps us ensure a safe and compliant experience for you.
                                                        </Typography>
                                                        </Grid>
                                                </Grid>
                                        </Grid>
                                    </FxCardHeader>
                                    <FxCardBody id="customer-signup-info-card#card-body" className="fx-info-card fx-margin-top-reducer" >
                                        <Grid xs={12} sm={12} >
                                            <Grid xs={12} container className="fx-info-card-form" spacing={2} item>
                                                <Grid item xs={12} sm={12}>
                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12}>
                                                    <FxLabelView id="customer-signup-info-label" className="" >MORE ABOUT YOU</FxLabelView>
                                                </Grid>
                                                <Grid item xs={12} sm={12} >
                                                    <FxTextEdit register={{ ...register("firstName") }} type="text" className={errors.firstName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signup-firstName" label="First Name" name="firstName" defaultValue={getKey('firstName')} isEditable={false} 
                                                    onBlur={(e) => handleAutoSave('firstName', e)}/>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FxTextEdit register={{ ...register("middleName") }} type="text" className={errors.middleName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: false }} id="signup-middleName" label="Middle Name (optional)" name="middleName" defaultValue={props?.data?.middleName ? props.data?.middleName : ''} 
                                                    onBlur={(e) => handleAutoSave('middleName', e)}/>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FxTextEdit register={{ ...register("lastName") }} type="text" className={errors.lastName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signup-lastName" label="Last Name" name="lastName" defaultValue={getKey('lastName')} isEditable={false} 
                                                    onBlur={(e) => handleAutoSave('lastName', e)}/>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FxDateEdit register={{ ...register("dob") }} className={errors.dob ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: true }} id="signup-dob-textbox" label="Date of Birth" name="dob" variant="outlined" defaultValue={props?.data?.dob ? props.data?.dob : ''} 
                                                    onChange={(value) => handleDateOfBirthValueChange(value)} 
                                                    ageLimitMessage={dobErrorMsg.maxDate}
                                                    futureDateMessage={dobErrorMsg.futureDate}
                                                    maxDate={ageLimit(18)} setValue={setValue}  />
                                                    <FieldErrorMessageRender error={errors} fieldKey='dob' type='date'/>
                                                </Grid>


                                                {/*** Identification Info Fields ***/}
                                                <Grid
                                                container
                                                item
                                                xs={12}
                                                sm={12}
                                                display="flex"
                                                alignItems="center"
                                                >
                                                {/* Label */}
                                                <Grid item>
                                                    <FxLabelView id="business-owner-details-label" className="">
                                                    IDENTIFICATION INFO
                                                    </FxLabelView>
                                                </Grid>

                                                {/* Tooltip */}
                                                <Grid item sx={{ ml: 1 }} xs={1}> {/* Add some left margin for spacing */}
                                                    {ShowInfoToolTip(
                                                    'fx-business-owner-title-tooltip',
                                                    'To keep your account secure, we need to verify some details. This helps us ensure a safe and compliant experience for you.',
                                                    'right'
                                                    )}
                                                </Grid>
                                                </Grid>

                                                
                                                <Grid item xs ={12} sm={12}>
                                                    <FxMaterialSelect
                                                        register={{ ...register("taxIdentifier") }}
                                                        control={control}
                                                        rules={{ required: false }}
                                                        id="signUp-indivudal-form-card-tax-identifier"
                                                        name="taxIdentifier"
                                                        data={taxIdentifierData}
                                                        readOnly={props?.disableTaxIdentifierDropdown || Boolean(props?.data?.ssn || props?.data?.itin)}
                                                        value={defaultTaxIdentifier}
                                                        label="Identification Method"
                                                        setValue={setValue}
                                                    />
                                                </Grid>
                                                <Grid container item xs={12} sm={12} display="flex" alignItems="center">
                                                    <Grid item xs>
                                                        <FxTextEditSSN
                                                            key={taxIdentifier}
                                                            register={{ ...register(taxIdentifier) }}
                                                            className={errors.ssn || errors.itin ? "border-error-input fx-input-edit" : "fx-input-edit"}
                                                            error={errors?.ssn || errors?.itin}
                                                            control={control}
                                                            rules={taxIdentifier === 'ssn' ? {...setSsnValidationOptions(true)} : {...setItinValidationOptions(true)}}
                                                            id="signUp-indivudal-form-card-ssn-itin"
                                                            label={`${taxIdentifier === 'ssn' ? 'Social Security Number' : 'Individual Taxpayer Identification Number'}`}
                                                            placeholder="XXX-XX-XXXX"
                                                            name={taxIdentifier}
                                                            variant="outlined"
                                                            setValue={setValue}
                                                            setError={setError}
                                                            clearErrors={clearErrors}
                                                            defaultValue={props?.data?.ssn || props?.data?.itin}
                                                            onBlur={(e: any) => 
                                                                handleAutoSave(taxIdentifier, e)
                                                            }
                                                        />                                             
                                                    </Grid>
                                                    <Grid item xs={1} container justifyContent="center" alignItems="center">
                                                        {ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-end')}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={isSmallScreen ? 11 : 12} sm={11} className="fx-individual-details-error-row" >
                                                    <FieldErrorMessageRender error={errors} fieldKey={taxIdentifier === 'ssn' ? 'ssn' : 'itin'} />
                                                </Grid>

                                                <Grid item xs={12} sm={12}>
                                                    <FxLabelView id="customer-signup-info-label-primary-address">YOUR CONTACT INFO</FxLabelView>
                                                </Grid>
                                                <FxTextEdit register={{ ...register("id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-id-id"  name="id" variant="outlined" defaultValue={props.data?.id} />
                                                <FxTextEdit register={{ ...register("address_id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-address-id"  name="address_id" variant="outlined" defaultValue={props.data?.address_id} />
                                                <Grid item xs={12} sm={6}>
                                                    <FxTextEdit register={{ ...register('addressLine1') }} control={control} className={errors['addressLine1'] ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} rules={setAddressLine1Validation} id={'addressLine1'} label="Address Line 1" name={'addressLine1'} variant="outlined" defaultValue={props?.data?.addressLine1 ? props?.data?.addressLine1 : ''} onChange={(e: any) => { handleAddressChange(e, setValue, setError, clearErrors) }} 
                                                    onBlur={(e) => handleAutoSave('addressLine1', e)}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='addressLine1'/>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <FxTextEdit register={{ ...register('addressLine2') }} control={control} className="fx-input-edit fs-mask" id={'addressLine2'} label="Address Line 2 (optional)" name={'addressLine2'} variant="outlined" defaultValue={props?.data?.addressLine2 ? props?.data?.addressLine2 : ''} 
                                                    onBlur={(e) => handleAutoSave('addressLine2', e)}/>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FxTextEdit register={{ ...register('city') }} control={control} rules={setCityValidation(true)} className={errors['city'] ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} id={'city'} label="City" name={'city'} variant="outlined" defaultValue={props?.data?.city ? props?.data?.city : ''}  
                                                    onBlur={(e) => handleAutoSave('city', e)}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='city'/>
                                                </Grid>
                                                <Grid item xs={12} sm={!isSmallScreen ? 8 : 12}>
                                                    <FxMaterialSelect register={{ ...register('state') }} control={control} className={errors['state'] ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} rules={{ required: true }} id={'state'} name={'state'} data={usa_state}
                                                        label="State" setValue={setValue} value={props?.data?.['state'] ? props?.data?.['state'] : ''} onChange={(e) => handleStateOnChangeEvents(e, 'state')}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='state'/>
                                                </Grid>
                                                <Grid item xs={12} sm={!isSmallScreen ? 4 : 12}>
                                                    <FxTextEdit register={{ ...register('zip') }} control={control} rules={setZipValidationOptions(true)} className={errors['zip'] ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} id={'zip'} label="Zip" name={'zip'} variant="outlined" defaultValue={props?.data?.zip ? props?.data?.zip : ''} onChange={(e: any) => { handleZipChange(e, setValue, setError, clearErrors) }} onKeyDown={(e: any) => { handleKeyDownChange(e, setValue) }} 
                                                        onBlur={(e) => handleAutoSave('zip', e)}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='zip'/>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                <FxPhoneEdit register={register} control={control} rules={setPhoneValidationOptions(true)} className={errors.mobilePhone ? "border-error-input fx-input-edit" : "fx-input-edit "} id="signup-mobilePhone" name="mobilePhone" label="Phone Number" defaultCountryCode={getKey('countryCode')} defaultValue={convertToPhoneDisplayFormat(getKey('phone'))} isEditable={invitationType !== "SMS" ? true : false} setValue={setValue} setError={setError} clearErrors={clearErrors} 
                                                {...(invitationType === 'SMS' && { suffixIcon: PhoneVerificationICon })}
                                                onBlur={(e) => handleAutoSave('mobilePhone', e)}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='mobilePhone'/>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={6}>
                                                    <FxTextEdit register={{ ...register("email") }} type="email" className={errors.email ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit login-email fs-mask"} control={control} rules={setEmailValidationOptions} id="signup-email" label="Email" name="email" defaultValue={getKey('email')} isEditable={invitationType !== "EMAIL" ? true : false} {...(invitationType === 'EMAIL' && { suffixIcon: PhoneVerificationICon })}/>
                                                    <FieldErrorMessageRender error={errors} fieldKey='email'/>
                                                </Grid>
                                                <Grid className={isSmallScreen ? 'fx-margin-top-2' : ''} item xs={12} sm={12}>
                                                    <Divider />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </FxCardBody>
                                    <FxCardFooter id="customer-signup-Card-Footer" className={isSmallScreen?"fx-footer fx-sticky-button-form-container":"fx-footer"}>
                                    {!isSmallScreen && <Grid container direction="row" justifyContent="flex-start" className="fx-modal-footer fx-footer-kyc">
                                            <Typography id="business-details-card-title"className="fx-footer-kyc-text">   
                                            Your changes are autosaved
                                            </Typography>
                                        </Grid>}
                                        <Grid container direction="row" justifyContent="flex-end" className="fx-modal-footer fx-footer-kyc">
                                            <span className="fx-padding-right-16" />
                                            <FxButton
                                                disableRipple={false}
                                                className="fx-button fx-button-theme"
                                                id="add-mailing-address-save-changes"
                                                type="submit"
                                                isSubmitting={props?.isLoading}
                                            > Continue
                                            </FxButton>
                                        </Grid>
                                    </FxCardFooter>
                                </form>}
                            </div>
                        </FxCard>
                    </Grid>
                </Grid>
            </Grid>
        );
    }));